// TODO :: Vue 3 - catch all no longer supported https://stackoverflow.com/a/64186073/865803
import { NavigationGuardNext, RouteLocationNormalized, RouteLocationNormalizedLoaded } from 'vue-router';
import { validateMiddleware } from './middleware';

export const routeAuthorization = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded,
  next: NavigationGuardNext
) => {
  try {

    return await validateMiddleware({ to, from, next });

  } catch (error) {
    // This catch should never occur, but never say never...
    console.error('routeAuthorization Error - This catch should never occur, but never say never...', { error });

    return next({ name: 'shadow-zone' });
    // return next({ name: CONFIG_ROUTES.APP_HOME });
  }
};
